import focusElement from './focusElement';

const selectors = {
  errorMessage: 'form .errors',
  successMessage: '.form__message--success'
};

const messages = {
  success: 'Your submission was successful.',
  error: 'There was a problem submitting this form. Please resolve the following errors:',
}

const focusFormMessages = () => {
  const errorMessage = document.querySelector(selectors.errorMessage);
  const successMessage = document.querySelector(selectors.successMessage);

  if (!errorMessage && !successMessage) return;

  const summaryText = errorMessage ? messages.error : messages.success;
  const formMessage = errorMessage ? errorMessage : successMessage;
  const parentElement = formMessage.parentNode;
  const summaryElement = document.createElement('span');
  summaryElement.innerHTML = summaryText;
  parentElement.insertBefore(summaryElement, formMessage);

  setTimeout(() => {
    focusElement(summaryElement, { makeFocusable: true });
  }, 800);
};

document.addEventListener('DOMContentLoaded', () => {
  focusFormMessages();
});

export default focusFormMessages;
